module.exports = __webpack_public_path__ + "static/media/9_cookieman.7a02cf1a.svg";